<template>
  <footer
      :class="{ [`footer-${type}`]: type }"
      :data-background-color="backgroundColor"
      class="footer"
  >
    <cookies/>
    <div class="container">
      <nav>
        <ul>
          <li>
            Hjemmeside lavet af
            <strong>Søren Berg Glasius</strong>
          </li>
        </ul>
      </nav>
      <div class="copyright">
        &copy; {{ year }}, Designed by
        <a href="https:///www.invisionapp.com" rel="noopener" target="_blank">Invision</a>. Coded by
        <a href="https://binarcode.com" rel="noopener" target="_blank">BinarCode</a>
        and<a href="https://www.creative-tim.com" rel="noopener" target="_blank">Creative Tim</a>.
      </div>
    </div>
  </footer>
</template>
<script>

import {Cookies} from "@/components";

export default {
  components: {Cookies},
  props: {
    backgroundColor: String,
    type: String
  },
  data() {
    return {
      year: new Date().getFullYear()
    };
  }
};
</script>
<style lang="scss" scoped>
@import "~bootstrap/scss/bootstrap-grid";

@include media-breakpoint-down(md) {
  .copyright {
    display: none;
  }
}
</style>
